(function () {
  /* Szállítási naptár (Europe/Budapest, munkanapok). Feladás: következő munkanap (péntek/szombat/vasárnap -> hétfő). Kézbesítés: feladás + 1–2 munkanap. */
  var HU_DAYS = ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'];
  var HU_ON = ['vasárnap', 'hétfőn', 'kedden', 'szerdán', 'csütörtökön', 'pénteken', 'szombaton'];
  var HU_MONTHS = ['jan.', 'febr.', 'márc.', 'ápr.', 'máj.', 'jún.', 'júl.', 'aug.', 'szept.', 'okt.', 'nov.', 'dec.'];
  var EN_DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  var EN_MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  var hu = (document.documentElement.lang || '').toLowerCase().indexOf('hu') === 0;

  function bpNow() {
    try {
      var p = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Budapest', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false })
        .formatToParts(new Date()).forEach(function (x) { p[x.type] = x.value; });
      return new Date(+p.year, +p.month - 1, +p.day, +p.hour % 24, +p.minute, +p.second);
    } catch (e) { return new Date(); }
  }
  function day(d) { return new Date(d.getFullYear(), d.getMonth(), d.getDate()); }
  function plusDays(d, n) { var x = day(d); x.setDate(x.getDate() + n); return x; }
  function isWork(d) { var w = d.getDay(); return w !== 0 && w !== 6; }
  function addWork(d, n) { var x = day(d); while (n > 0) { x.setDate(x.getDate() + 1); if (isWork(x)) n--; } return x; }
  function calc() {
    var now = bpNow(), today = day(now), dispatch = addWork(today, 1), last = today;
    while (addWork(plusDays(last, 1), 1).getTime() === dispatch.getTime()) last = plusDays(last, 1);
    var deadline = plusDays(last, 1);
    return { today: today, dispatch: dispatch, from: addWork(dispatch, 1), to: addWork(dispatch, 2), left: deadline - now };
  }
  function fmt(d) { return hu ? HU_MONTHS[d.getMonth()] + ' ' + d.getDate() + '.' : EN_MONTHS[d.getMonth()] + ' ' + d.getDate(); }
  function fmtRange(a, b) {
    if (a.getMonth() === b.getMonth()) {
      return hu ? HU_MONTHS[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate() + '.' : EN_MONTHS[a.getMonth()] + ' ' + a.getDate() + '–' + b.getDate();
    }
    return fmt(a) + ' – ' + fmt(b);
  }
  function dayRange(a, b) { var D = hu ? HU_DAYS : EN_DAYS; return D[a.getDay()] + '–' + D[b.getDay()]; }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function countdown(ms) {
    var d = Math.floor(ms / 86400000), h = Math.floor((ms % 86400000) / 3600000), m = Math.floor((ms % 3600000) / 60000);
    if (hu) return d > 0 ? { core: d + ' nap ' + h + ' órán', suf: ' belül' } : { core: pad(h) + ' óra ' + pad(m) + ' perc', suf: 'en belül' };
    return d > 0 ? { core: d + 'd ' + h + 'h', suf: '' } : { core: pad(h) + 'h ' + pad(m) + 'm', suf: '' };
  }
  window.candyShipping = calc;

  /* Kosár: várható kiszállítás */
  if (!customElements.get('candy-delivery-eta')) {
    class CandyDeliveryEta extends HTMLElement {
      connectedCallback() { this.textEl = this.querySelector('[data-eta-text]'); this.render(); this.timer = setInterval(this.render.bind(this), 30000); }
      disconnectedCallback() { clearInterval(this.timer); }
      render() {
        if (!this.textEl) return;
        var c = calc(), cd = countdown(c.left), when = dayRange(c.from, c.to) + ' (' + fmtRange(c.from, c.to) + ')';
        this.textEl.innerHTML = hu
          ? 'Várható kiszállítás: <strong>' + when + '</strong>, ha <strong class="candy-green">' + cd.core + '</strong>' + cd.suf + ' rendelsz.'
          : 'Estimated delivery: <strong>' + when + '</strong> if you order within <strong class="candy-green">' + cd.core + '</strong>.';
      }
    }
    customElements.define('candy-delivery-eta', CandyDeliveryEta);
  }

  /* Termékoldali idővonal (Section Store delivery timer) */
  function fixTimeline() {
    document.querySelectorAll('[id^="ss-delivery-body"]').forEach(function (body) {
      var dates = body.querySelectorAll('p[class^="delivery-date-"], p[class*=" delivery-date-"]');
      var titles = body.querySelectorAll('p[class^="delivery-title-"], p[class*=" delivery-title-"]');
      if (dates.length < 3) return;
      var c = calc();
      var vals = [fmt(c.today), fmt(c.dispatch), fmtRange(c.from, c.to)];
      for (var i = 0; i < 3; i++) if (dates[i].textContent !== vals[i]) dates[i].textContent = vals[i];
      var t0 = hu ? 'Ma' : 'Today';
      if (titles[0] && titles[0].textContent !== t0) titles[0].textContent = t0;
      var cdEl = body.querySelector('.candy-order-cd');
      if (!cdEl) {
        cdEl = document.createElement('p');
        cdEl.className = 'candy-order-cd';
        body.insertBefore(cdEl, body.firstChild);
      }
      var cd = countdown(c.left);
      var html = hu
        ? 'Rendelj <span class="candy-green">' + cd.core + '</span>' + cd.suf + ', és <strong>' + HU_ON[c.dispatch.getDay()] + '</strong> feladjuk!'
        : 'Order within <span class="candy-green">' + cd.core + '</span> and we ship it on <strong>' + EN_DAYS[c.dispatch.getDay()] + '</strong>!';
      if (cdEl.innerHTML !== html) cdEl.innerHTML = html;
    });
  }
  setInterval(fixTimeline, 30000);

  /* Opció címkék: Größe -> Méret, Schuhgröße -> Cipőméret */
  var SIZE = hu ? 'Méret' : 'Size', SHOE = hu ? 'Cipőméret' : 'Shoe size';
  function mapLabel(t) {
    t = (t || '').trim().toLowerCase().replace(':', '');
    if (t === 'größe' || t === 'grösse' || t === 'groesse' || t === 'size' || t === 'méret') return SIZE;
    if (t === 'schuhgröße' || t === 'schuhgrösse' || t === 'schuhgroesse' || t === 'shoe size' || t === 'cipőméret') return SHOE;
    return null;
  }
  function fixLabels() {
    document.querySelectorAll('.radio__legend__label, .select__label, .cart__item__selected-options span:first-child').forEach(function (el) {
      var isCart = el.closest('.cart__item__selected-options');
      var m = mapLabel(el.textContent);
      if (!m) return;
      var want = isCart ? m + ':' : m;
      if (el.textContent !== want && !el.querySelector('button,a')) el.textContent = want;
    });
  }

  /* Készlet sor: "Készleten – X–Y napon belül nálad" */
  function fixStock() {
    var c = calc(), a = Math.round((c.from - c.today) / 864e5), b = Math.round((c.to - c.today) / 864e5);
    var txt = hu ? 'Készleten – <strong>' + a + '–' + b + ' napon belül nálad</strong>' : 'In stock – <strong>with you in ' + a + '–' + b + ' days</strong>';
    document.querySelectorAll('.variant__countdown--in, .variant__countdown--low').forEach(function (el) {
      if (el.getAttribute('data-candy') === txt) return;
      var cnt = el.querySelector('[data-remaining-count]');
      el.innerHTML = txt;
      if (cnt) { cnt.hidden = true; el.appendChild(cnt); }
      el.setAttribute('data-candy', txt);
    });
  }

  /* "1/1 · Egyetlen darab" címke az ár mellett (ha 1 db van készleten) */
  function fixUnique() {
    var cnt = document.querySelector('.template-product product-sticky [data-remaining-count]');
    var wrapEl = document.querySelector('.template-product product-sticky .variant__countdown');
    document.querySelectorAll('.template-product product-sticky .product__price').forEach(function (p) {
      var one = !!(cnt && cnt.textContent.trim() === '1' && wrapEl && /count-is-low/.test(wrapEl.className));
      var tag = p.querySelector('.candy-one');
      if (one && !tag) { tag = document.createElement('span'); tag.className = 'candy-one'; tag.textContent = hu ? '1/1 · Egyetlen darab' : '1/1 · One of one'; p.appendChild(tag); }
      if (!one && tag) tag.remove();
    });
  }

  /* ---------- Magyar fordítások a HU domainen: termékleírás, opcióértékek, üres kosár gomb ---------- */
  var HU_DESC = [
    [/\bCo?[a-z]?nd(ition)?\s*:/gi, 'Állapot:'], [/\bZustand\s*:/gi, 'Állapot:'],
    [/\bLength\s*:/gi, 'Hossz:'], [/\bLänge\s*:/gi, 'Hossz:'],
    [/\bWidth\s*:/gi, 'Szélesség:'], [/\bBreite\s*:/gi, 'Szélesség:'],
    [/\bSize\s*:/gi, 'Méret:'], [/\bGröße\s*:/gi, 'Méret:'],
    [/\bTrackjacket\s*:/gi, 'Felső:'], [/\bTrackpants\s*:/gi, 'Nadrág:'],
    [/\bfits for (\S+?) ?as ?well\b/gi, '$1-re is jó'], [/\bfits for (\S+)/gi, '$1-re jó'],
    [/\bVery good\b/gi, 'Nagyon jó'], [/\bSehr gut\b/gi, 'Nagyon jó'], [/\bExcellent\b/gi, 'Kiváló'],
    [/\bGood\b/g, 'Jó'], [/\bGut\b/g, 'Jó'], [/\blast pic\b/gi, 'utolsó kép'], [/\bbit fluffy\b/gi, 'kicsit bolyhos']
  ];
  var HU_EXACT = { 'one size': 'Egy méret', 'normal size': 'Normál méret', 'shop all': 'Vásárolj most', 'shop now': 'Vásárolj most', 'view product →': 'Megnézem →' };
  var huDone = typeof WeakSet !== 'undefined' ? new WeakSet() : null;
  function fixHu() {
    if (!hu || !huDone || !document.body) return;
    var w = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT), n;
    while ((n = w.nextNode())) {
      if (huDone.has(n)) continue;
      var par = n.parentElement;
      if (!par || /^(SCRIPT|STYLE|NOSCRIPT|TEXTAREA)$/.test(par.tagName)) { huDone.add(n); continue; }
      var raw = n.nodeValue, t = raw.trim();
      if (!t) continue;
      var ex = HU_EXACT[t.toLowerCase()];
      if (ex) { n.nodeValue = raw.replace(t, t === t.toUpperCase() ? ex.toUpperCase() : ex); huDone.add(n); continue; }
      if (par.closest('[class*="product-tabs-answer-"], .product__description, .product-single .rte, product-sticky .rte')) {
        var v = raw;
        HU_DESC.forEach(function (r) { v = v.replace(r[0], r[1]); });
        if (v !== raw) n.nodeValue = v;
      }
      huDone.add(n);
    }
  }

  /* Ingyenes szállítás szöveg magyarul */
  function fixShipping() {
    if (!hu) return;
    document.querySelectorAll('[data-message-default]').forEach(function (el) {
      var amt = el.querySelector('[data-left-to-spend]');
      if (!amt || el.getAttribute('data-candy') === '1') return;
      el.textContent = '';
      el.appendChild(document.createTextNode('Még '));
      el.appendChild(amt);
      el.appendChild(document.createTextNode(' és INGYENES a szállítás! 🚚'));
      el.setAttribute('data-candy', '1');
    });
    document.querySelectorAll('.cart-message__success').forEach(function (el) {
      if (el.getAttribute('data-candy') === '1') return;
      el.textContent = '🎉 Gratulálunk! INGYENES a szállításod!';
      el.setAttribute('data-candy', '1');
    });
  }

  /* Méret + Állapot alapból nyitva (addig próbálja, amíg a Section Store kattintás-kezelője be nem tölt) */
  function openSizeTab() {
    document.querySelectorAll('[class*="product-tabs-toggle-"]').forEach(function (tg) {
      if (tg.getAttribute('data-candy-open') === 'done') return;
      var q = (tg.textContent || '').trim().toLowerCase();
      if (q.indexOf('méret + állapot') === -1 && q.indexOf('size + condition') === -1 && q.indexOf('product details') === -1) return;
      var ans = tg.parentElement.querySelector('[class*="product-tabs-answer-"]');
      if (!ans) return;
      if (getComputedStyle(ans).display !== 'none') { tg.setAttribute('data-candy-open', 'done'); return; }
      var n = +(tg.getAttribute('data-candy-open') || 0);
      if (n > 40) return;
      tg.setAttribute('data-candy-open', n + 1);
      tg.click();
    });
  }
  var openTimer = setInterval(function () { try { openSizeTab(); } catch (e) {} }, 300);
  setTimeout(function () { clearInterval(openTimer); }, 12000);

  /* Desktop: bélyegképek kattintása */
  function galleryFlkty(el) {
    var s = el && el.querySelector ? el.querySelector('.product-gallery__media-slider') : null;
    if (s && window.Flickity && window.Flickity.data(s)) return window.Flickity.data(s);
    var pi = el && el.closest ? el.closest('product-info') : null;
    return pi && pi.flkty ? pi.flkty : null;
  }
  document.addEventListener('click', function (e) {
    var th = e.target.closest && e.target.closest('.template-product .product-single__thumbnail');
    if (!th || window.innerWidth < 990) return;
    var list = Array.prototype.slice.call(th.parentElement.children);
    var idx = list.indexOf(th);
    var f = galleryFlkty(th.closest('.product-gallery'));
    if (f && idx > -1) {
      e.preventDefault();
      f.select(idx);
      list.forEach(function (x, i) { x.classList.toggle('is-nav-selected', i === idx); });
    }
  }, true);
  function relayout() {
    if (window.innerWidth < 990) return;
    var g = document.querySelector('.template-product .product-gallery');
    var s = g && g.querySelector('.product-gallery__media-slider');
    var f = s && galleryFlkty(g);
    if (f && !s.getAttribute('data-candy-rl')) { s.setAttribute('data-candy-rl', '1'); setTimeout(function () { f.resize(); }, 60); }
  }

  /* Egészítsd ki a szetted + fizetési ikonok */
  var fitLoading = false;
  function fitAnchor() {
    var sticky = document.querySelector('.template-product product-sticky');
    if (!sticky) return null;
    var tabs = sticky.querySelector('[class*="ss_product_tabs"], [class*="product-tabs-"]');
    return tabs ? (tabs.closest('product-sticky > *') || tabs) : sticky.lastElementChild;
  }
  function loadFit(force) {
    if (fitLoading) return;
    var anchor = fitAnchor();
    if (!anchor) return;
    var existing = document.querySelector('.candy-fit-wrap');
    if (existing && !force) return;
    fitLoading = true;
    fetch(location.pathname + '?section_id=candy-complete-fit&_=' + Date.now(), { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fit = tmp.querySelector('[data-candy-fit]');
        var wrap = document.querySelector('.candy-fit-wrap');
        if (!wrap) { wrap = document.createElement('div'); wrap.className = 'candy-fit-wrap'; anchor.parentNode.insertBefore(wrap, anchor.nextSibling); }
        wrap.innerHTML = '';
        if (fit) wrap.appendChild(fit);
        var pay = tmp.querySelector('[data-candy-pay]');
        if (pay) document.querySelectorAll('.ss-payment-list').forEach(function (l) { var c = pay.cloneNode(true); c.hidden = false; l.parentNode.replaceChild(c, l); });
      })
      .catch(function () {})
      .then(function () { fitLoading = false; });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-candy-add]');
    if (!b) return;
    e.preventDefault();
    if (b.classList.contains('is-loading') || b.classList.contains('is-added')) return;
    b.classList.add('is-loading');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +b.getAttribute('data-candy-add'), quantity: 1 }] }) })
      .then(function (r) { if (!r.ok) throw r; return fetch('/cart.js').then(function (c) { return c.json(); }); })
      .then(function (cart) {
        b.classList.remove('is-loading'); b.classList.add('is-added');
        b.querySelector('.candy-fit__plus').textContent = '✓';
        document.querySelectorAll('[data-cart-count], [data-cart-items-qty], .cart__toggle [data-cart-count]').forEach(function (el) { if (/^\s*\(?\d*\)?\s*$/.test(el.textContent)) el.textContent = cart.item_count; });
        document.querySelectorAll('.cart__toggle').forEach(function (t) { t.classList.add('cart__toggle--has-items'); });
        document.dispatchEvent(new CustomEvent('theme:cart:refresh', { bubbles: true }));
        setTimeout(function () { loadFit(true); }, 1200);
      })
      .catch(function () { b.classList.remove('is-loading'); b.classList.add('is-error'); setTimeout(function () { b.classList.remove('is-error'); }, 1500); });
  }, true);

  function fix() {
    try { fixLabels(); fixShipping(); fixTimeline(); fixStock(); fixUnique(); fixHu(); relayout(); if (document.body && document.body.classList.contains('template-product')) loadFit(false); } catch (e) {}
  }
  window.candyCartFix = fix;
  document.addEventListener('DOMContentLoaded', fix);
  var q = null;
  new MutationObserver(function () { if (q) return; q = setTimeout(function () { q = null; fix(); }, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  fix();
})();
